import OutlinedInput from '@mui/material/OutlinedInput';
import Stack from '@mui/material/Stack';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BtnGradient from '../common/button/BtnGradient';
import BtnOutlineGradient from '../common/button/BtnOutlineGradient';
import { getToken } from 'src/utils/auth';
import { postAPI } from 'src/utils/api';
import { useNotify } from 'src/context/ContextNotify';

const rowStyle = {
  '&:last-child td, &:last-child th': { border: 0 },
  '&.MuiTableRow-root .MuiTableCell-root.MuiTableCell-body': {
    py: '16px',
    borderBottom: '1px solid #F3F3F3',
  },
};

const MailEdit = (props: any) => {
  const navigate = useNavigate();
  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const notifyContext = useNotify();
  const [data, setData] = useState({
    subject: '',
    body: '',
  });

  useEffect(() => {
    if (props.email) {
      setData({
        subject: props.email.contents.subject || '',
        body: props.email.contents.body || '',
      });
    }
  }, [props.email]);

  const resizeTextArea = () => {
    if (textAreaRef) {
      (textAreaRef?.current as any).style.height = 'auto';
      (textAreaRef?.current as any).style.height =
        textAreaRef?.current?.scrollHeight + 'px';
    }
  };

  useEffect(resizeTextArea, [data.body]);

  const handleEditClick = () => {
    const dataForm = {
      ...data,
      id: props.email.id,
    };

    // if (!validateForm()) {
    //   return;
    // }
    try {
      const token = getToken();
      postAPI(`/master/email-save?token=${token}`, { ...dataForm }).then(
        (res) => {
          if (res && res.code === 200) {
            notifyContext.setNotifyMessage({
              show: true,
              message: '保存出来ました。',
              type: 'success',
            });
            navigate(`/master/email-view?id=${props.email.id}`);
          }
          if (res.code === 501 || res.code === 500) {
            notifyContext.setNotifyMessage({
              show: true,
              message: res.msg || 'Failed to post data',
              type: 'error',
            });
          }
        }
      );
    } catch (error) {
      console.error('Failed to post data:', error);
      return;
    }
  };

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    setData((prevState: any) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCancelClick = () => {
    navigate(`/master/email-view?id=${props.email.id}`);
  };

  const handleKeywordClick = (keyword: string) => {
    let textarea = document.getElementById('mail-body') as HTMLTextAreaElement;
    let start_position = textarea ? textarea.selectionStart : 0;
    let end_position = textarea ? textarea.selectionEnd : 0;

    const result = `${textarea.value.substring(
      0,
      start_position
    )}${keyword}${textarea.value.substring(
      end_position,
      textarea.value.length
    )}`;
    setData((prevState: any) => ({
      ...prevState,
      body: result,
    }));
  };

  return (
    <>
      <Stack direction={'row'} spacing={'20px'}>
        <TableContainer
          component={Paper}
          sx={{
            boxShadow: 'none',
            // width: '100%',
            flex: 2,
            height: '100%',
          }}
        >
          <Table
            sx={{
              minWidth: 470,
              '& .MuiTableCell-root.MuiTableCell-head': {
                borderBottom: '1px solid #F3F3F3',
                fontWeight: 700,
                p: '6px 16px',
                fontSize: '14px',
              },
              '& .MuiTableCell-root.MuiTableCell-body': {
                color: 'primary.dark',
                fontSize: '14px',
                py: '6px',
              },
            }}
            aria-label='simple table'
          >
            <TableBody sx={{ '&.MuiTableBody-root th': { fontWeight: 700 } }}>
              <TableRow sx={rowStyle}>
                <TableCell component={'th'} sx={{ minWidth: '150px' }}>
                  テンプレート名
                </TableCell>
                <TableCell sx={{ whiteSpace: 'pre-line' }}>
                  {props.email ? props.email.name : ''}
                </TableCell>
              </TableRow>
              <TableRow sx={rowStyle}>
                <TableCell component={'th'} sx={{ minWidth: '150px' }}>
                  カテゴリー
                </TableCell>
                <TableCell sx={{ whiteSpace: 'pre-line' }}>
                  {props.email ? props.email.category : ''}
                </TableCell>
              </TableRow>
              <TableRow sx={rowStyle}>
                <TableCell component={'th'} sx={{ minWidth: '150px' }}>
                  件名
                </TableCell>
                <TableCell sx={{ whiteSpace: 'pre-line' }}>
                  <OutlinedInput
                    sx={{
                      fontSize: '14px',
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#BDBDBD',
                      },
                      '& .MuiInputBase-input': { padding: '8px 14px' },
                      '& input::placeholder': {
                        fontSize: '14px',
                        fontWeight: 500,
                        color: '#CCD1D9',
                        opacity: 1,
                      },
                      backgroundColor: 'primary.light',
                      width: '100%',
                    }}
                    id='subject'
                    aria-describedby='outlined-weight-helper-text'
                    inputProps={{
                      'aria-label': 'weight',
                    }}
                    value={data.subject}
                    type='text'
                    name='subject'
                    onChange={(event) => handleInputChange(event)}
                  />
                </TableCell>
              </TableRow>
              <TableRow sx={rowStyle}>
                <TableCell component={'th'} sx={{ minWidth: '150px' }}>
                  本文
                </TableCell>
                <TableCell sx={{ whiteSpace: 'pre-line' }}>
                  <textarea
                    value={data.body}
                    name='body'
                    onChange={(event) => handleInputChange(event)}
                    rows={5}
                    ref={textAreaRef}
                    id='mail-body'
                    style={{
                      width: '100%',
                      maxWidth: '100%',
                      height: 'auto',
                      resize: 'none',
                      overflowY: 'hidden',
                    }}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <TableContainer
          component={Paper}
          sx={{
            boxShadow: 'none',
            // width: '100%',
            flex: 1,
            height: '100%',
          }}
        >
          <Table>
            <TableBody sx={{ '&.MuiTableBody-root th': { fontWeight: 700 } }}>
              {props.email &&
                Array.isArray(props.email.keywords) &&
                props.email.keywords.map((keyword: any, index: number) => {
                  return (
                    <TableRow
                      key={index}
                      sx={{ ...rowStyle, cursor: 'pointer' }}
                      hover
                      onClick={() => handleKeywordClick(keyword)}
                    >
                      <TableCell sx={{ whiteSpace: 'pre-line' }}>
                        {keyword}
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
      <Stack direction={'row'} spacing={'20px'}>
        <BtnGradient text='登録' handleButtonClick={handleEditClick} />
        <BtnOutlineGradient
          text='キャンセル'
          handleButtonClick={handleCancelClick}
        />
      </Stack>
    </>
  );
};

export default MailEdit;
